// src/services/empresaService.js
import axios from "axios";

// Quita cualquier "/" al final para evitar dobles slashes al concatenar
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL = `${API_BASE}/api/empresas`;

/** Obtener todas las empresas */
export const obtenerEmpresas = () => axios.get(API_URL);

/**
 * Obtener una empresa por ID.
 * - Si tu backend expone GET /api/empresas/{id}, usamos esa ruta.
 * - Si no existe, como fallback probamos /api/empresas?id=.
 * Ajusta según tu API si la PK es EMPRESA y no Id.
 */
export const crearEmpresa = (empresa) => axios.post(API_URL, empresa);
export const actualizarEmpresa = (id, empresa) => axios.put(`${API_URL}/${id}`, empresa);

export const obtenerCertificadosStatus = (empresa) =>
  axios.get(`${API_URL}/${empresa}/certificados-status`);

export const descargarCertificado = (empresa, tipo) =>
  axios.get(`${API_URL}/${empresa}/certificados/${tipo}`, { responseType: "blob" });

export const subirCertificados = (empresa, cerFile, keyFile, pwdKey, usuarioPac, passwordPac,
  urlTimbrado40, urlTimbrado40Pruebas, urlCancelacion, urlCancelacionPruebas, ambientePruebas) => {
  const fd = new FormData();
  if (cerFile) fd.append("cer", cerFile);
  if (keyFile) fd.append("key", keyFile);
  if (pwdKey) fd.append("pwdKey", pwdKey);
  if (usuarioPac !== undefined) fd.append("usuarioPac", usuarioPac);
  if (passwordPac !== undefined) fd.append("passwordPac", passwordPac);
  if (urlTimbrado40 !== undefined) fd.append("urlTimbrado40", urlTimbrado40);
  if (urlTimbrado40Pruebas !== undefined) fd.append("urlTimbrado40Pruebas", urlTimbrado40Pruebas);
  if (urlCancelacion !== undefined) fd.append("urlCancelacion", urlCancelacion);
  if (urlCancelacionPruebas !== undefined) fd.append("urlCancelacionPruebas", urlCancelacionPruebas);
  fd.append("ambientePruebas", ambientePruebas ? "true" : "false");
  return axios.put(`${API_URL}/${empresa}/certificados`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const obtenerLogosStatus = (empresa) =>
  axios.get(`${API_URL}/${empresa}/logos-status`);

export const subirLogos = (empresa, logoPrincipal, logoSecundario) => {
  const fd = new FormData();
  if (logoPrincipal)  fd.append("logoPrincipal",  logoPrincipal);
  if (logoSecundario) fd.append("logoSecundario", logoSecundario);
  return axios.put(`${API_URL}/${empresa}/logos`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const obtenerEmpresa = async (id) => {
  try {
    // Ruta REST típica: /api/empresas/{id}
    const { data } = await axios.get(`${API_URL}/${id}`);
    return data;
  } catch (e) {
    // Fallback por si tu API usa querystring: /api/empresas?id=#
    try {
      const { data } = await axios.get(`${API_URL}`, { params: { id } });
      // si devuelve arreglo, toma el primero
      if (Array.isArray(data) && data.length) return data[0];
      if (data?.data && Array.isArray(data.data) && data.data.length) return data.data[0];
      return data;
    } catch (e2) {
      throw e2;
    }
  }
};
